var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandable-list-section"},_vm._l((_vm.paragraphs),function(paragraph){return _c('expandable-list-paragraph',{key:paragraph.title,staticClass:"expandable-list-section__paragraph",attrs:{"paragraph":paragraph}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }